import { Nullable } from "@core/domain/types/nullable.type";
import { injectable } from "inversify";
import { IrpfRetentionTypeEnumDto } from "@entity/data/dto/irpf-retention-type.dto";
import { IrpfRetentionTypeEnum } from "@entity/domain/models/irpf-retention-type.model";
import { IrpfRetentionPercentageTypeEnumDto } from "@entity/data/dto/irpf-retention-percentage-type.dto";
import { IrpfRetentionPercentageTypeEnum } from "@entity/domain/models/irpf-retention-percentage-type.model";

@injectable()
export class IrpfRetentionPercentageEnumMapper {
    map(
        irpfRetentionPercentageTypeEnumDto: IrpfRetentionPercentageTypeEnumDto,
    ): Nullable<IrpfRetentionPercentageTypeEnum> {
        switch (irpfRetentionPercentageTypeEnumDto) {
            case IrpfRetentionPercentageTypeEnumDto.fifteen:
                return IrpfRetentionPercentageTypeEnum.fifteen;
            case IrpfRetentionPercentageTypeEnumDto.seven:
                return IrpfRetentionPercentageTypeEnum.seven;
            default:
                return null;
        }
    }

    mapToDto(
        irpfRetentionPercentageTypeEnum: IrpfRetentionPercentageTypeEnum,
    ): IrpfRetentionPercentageTypeEnumDto {
        switch (irpfRetentionPercentageTypeEnum) {
            case IrpfRetentionPercentageTypeEnum.fifteen:
                return IrpfRetentionPercentageTypeEnumDto.fifteen;
            case IrpfRetentionPercentageTypeEnum.seven:
                return IrpfRetentionPercentageTypeEnumDto.seven;
        }
    }
}